export default __webpack_public_path__ + "static/media/servicetype_molding_192.bb296d3b.png";